/* JR6 · Product page — gallery, colour-filtered photos, photo swatches, add-ons, sticky bar, add-to-cart toast */
(() => {
  const $ = (s, r) => r.querySelector(s);
  const $$ = (s, r) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents, format) {
    const f = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    const m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    const kind = m ? m[1] : 'amount';
    const n = (Number(cents) || 0) / 100;
    const fmt = (dec, th, ds) => {
      const p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(ds);
    };
    let v;
    switch (kind) {
      case 'amount_no_decimals': v = fmt(0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(2, "'", '.'); break;
      default: v = fmt(2, ',', '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  class JRProduct {
    constructor(el) {
      this.el = el;
      const data = JSON.parse($('[data-jp-json]', el).textContent);
      this.data = data;
      this.variants = data.variants;
      this.current = this.variants.find((v) => v.id === data.current) || this.variants[0];
      this.m = (c) => money(c, data.moneyFormat);

      this.track = $('[data-jp-track]', el);
      this.stage = this.track && this.track.parentElement;
      this.slides = $$('[data-jp-slide]', el);
      this.thumbs = $$('[data-jp-thumb]', el);
      this.thumbWrap = $('[data-jp-thumbs]', el);
      this.counter = $('[data-jp-count]', el);
      this.form = $('form.jp-form', el);
      this.atc = $('[data-jp-atc]', el);
      this.qty = $('[data-jp-qty-input]', el);
      this.addons = $$('[data-jp-addon]', el);
      this.err = $('[data-jp-error]', el);
      this.bar = $('[data-jp-bar]', el);
      this.toast = $('[data-jp-toast]', el);
      this.lb = $('[data-jp-lb]', el);

      this.bindGallery();
      this.bindOptions();
      this.bindBuy();
      this.bindBar();
      this.bindLightbox();
      this.syncGallery();
      this.updateTotals();
    }

    /* ---------- Gallery ---------- */
    visible() { return this.slides.filter((s) => !s.hidden); }
    index() {
      const w = this.track.clientWidth || 1;
      return Math.round(this.track.scrollLeft / w);
    }
    goTo(i, smooth = true) {
      const vs = this.visible();
      if (!vs.length) return;
      const n = ((i % vs.length) + vs.length) % vs.length;
      this.track.scrollTo({ left: vs[n].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      if (!smooth) this.syncGallery();
    }
    syncGallery() {
      if (!this.track) return;
      const vs = this.visible();
      const i = Math.min(this.index(), vs.length - 1);
      if (this.counter) this.counter.textContent = vs.length > 1 ? `${i + 1} / ${vs.length}` : '';
      if (this.stage) this.stage.classList.toggle('single', vs.length < 2);
      const vt = this.thumbs.filter((t) => !t.hidden);
      vt.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
      const active = vt[i];
      if (active && this.thumbWrap) {
        const tw = this.thumbWrap;
        const target = active.offsetLeft - (tw.clientWidth - active.clientWidth) / 2;
        tw.scrollTo({ left: target, behavior: 'smooth' });
        const box = tw.parentElement;
        if (box) box.classList.toggle('fits', tw.scrollWidth <= tw.clientWidth + 2);
      }
      // pause any video that scrolled away
      this.slides.forEach((s) => {
        if (s !== vs[i]) $$('video', s).forEach((v) => v.pause());
      });
    }
    bindGallery() {
      if (!this.track) return;
      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.syncGallery());
      }, { passive: true });
      const prev = $('[data-jp-prev]', this.el);
      const next = $('[data-jp-next]', this.el);
      if (prev) prev.addEventListener('click', () => this.goTo(this.index() - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.index() + 1));
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index() + 1); }
      });
      this.thumbs.forEach((t) => t.addEventListener('click', () => {
        const vt = this.thumbs.filter((x) => !x.hidden);
        this.goTo(vt.indexOf(t));
      }));
      const step = (d) => this.thumbWrap && this.thumbWrap.scrollBy({ left: d * this.thumbWrap.clientWidth * 0.8, behavior: 'smooth' });
      const tp = $('[data-jp-tprev]', this.el);
      const tn = $('[data-jp-tnext]', this.el);
      if (tp) tp.addEventListener('click', () => step(-1));
      if (tn) tn.addEventListener('click', () => step(1));
      window.addEventListener('resize', () => this.goTo(this.index(), false));
    }
    filterColor(value, mediaId) {
      if (!this.data.filter || this.data.colorIndex < 0 || value == null) return;
      const c = String(value).toLowerCase();
      const has = this.slides.some((s) => s.dataset.color === c);
      this.slides.forEach((s, k) => {
        const show = !has || s.dataset.color === '-' || s.dataset.color === c;
        s.hidden = !show;
        if (this.thumbs[k]) this.thumbs[k].hidden = !show;
      });
      const vs = this.visible();
      let i = vs.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
      if (i < 0) i = vs.findIndex((s) => s.dataset.color === c);
      this.warm(c, 3);
      this.goTo(Math.max(i, 0), false);
    }
    /* Start loading a colour's first photos before it is shown, so switching colours doesn't flash blank. */
    warm(color, n) {
      if (color == null) return;
      const c = String(color).toLowerCase();
      let k = 0;
      this.slides.forEach((s) => {
        if (s.dataset.color !== c || k >= n) return;
        k += 1;
        $$('img[loading="lazy"]', s).forEach((img) => { img.loading = 'eager'; });
      });
    }
    bindWarm() {
      const ci = this.data.colorIndex;
      const fs = ci >= 0 && this.data.filter ? this.optSets[ci] : null;
      if (!fs) return;
      $$('input', fs).forEach((inp) => {
        const lb = inp.closest('label') || inp;
        const w = () => this.warm(inp.value, 3);
        lb.addEventListener('pointerenter', w, { once: true });
        lb.addEventListener('pointerdown', w, { once: true });
        inp.addEventListener('focus', w, { once: true });
      });
      const idle = window.requestIdleCallback ? (f) => window.requestIdleCallback(f, { timeout: 3000 }) : (f) => setTimeout(f, 1200);
      const go = () => idle(() => {
        this.thumbs.forEach((t) => $$('img[loading="lazy"]', t).forEach((img) => { img.loading = 'eager'; }));
        const seen = {};
        this.slides.forEach((s) => {
          const c = s.dataset.color;
          if (s.hidden && c && c !== '-' && !seen[c]) { seen[c] = true; this.warm(c, 1); }
        });
      });
      if (document.readyState === 'complete') go();
      else window.addEventListener('load', go, { once: true });
    }

    /* ---------- Options ---------- */
    bindOptions() {
      this.optSets = $$('[data-jp-opt]', this.el);
      this.optSets.forEach((fs) => fs.addEventListener('change', () => this.onOption()));
      this.bindWarm();
    }
    selected() {
      return this.optSets.map((fs) => { const i = $('input:checked', fs); return i ? i.value : null; });
    }
    onOption() {
      const sel = this.selected();
      this.optSets.forEach((fs, k) => { const b = $('[data-jp-opt-val]', fs); if (b) b.textContent = sel[k] || ''; });
      const v = this.variants.find((x) => x.options.every((o, k) => o === sel[k]));
      const ci = this.data.colorIndex;
      if (!v) {
        this.current = null;
        this.setAtc(false, this.data.strings.unavailable);
        if (ci >= 0) this.filterColor(sel[ci]);
        this.updateTotals();
        return;
      }
      this.current = v;
      $$('input[name="id"]', this.el).forEach((i) => { i.value = v.id; i.dispatchEvent(new Event('change', { bubbles: true })); });
      this.renderPrice(v);
      this.setAtc(v.available, v.available ? this.data.strings.addToCart : this.data.strings.soldOut);
      try {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) { /* noop */ }
      if (ci >= 0) this.filterColor(sel[ci], v.media);
      else if (v.media) {
        const i = this.visible().findIndex((s) => String(s.dataset.mediaId) === String(v.media));
        if (i >= 0) this.goTo(i, false);
      }
      if (this.bar) {
        const img = $('[data-jp-bar-img]', this.bar);
        if (img && v.img) img.src = v.img;
        const t = $('[data-jp-bar-variant]', this.bar);
        if (t) t.textContent = v.title;
      }
      this.updateTotals();
    }
    renderPrice(v) {
      const now = $('[data-jp-now]', this.el);
      const cmp = $('[data-jp-compare]', this.el);
      const save = $('[data-jp-save]', this.el);
      if (now) now.textContent = this.m(v.price);
      const on = v.compare > v.price;
      if (cmp) { cmp.hidden = !on; if (on) cmp.textContent = this.m(v.compare); }
      if (save) { save.hidden = !on; if (on) save.textContent = this.data.strings.save.replace('[amount]', this.m(v.compare - v.price)); }
    }
    setAtc(enabled, label) {
      [this.atc, this.bar && $('[data-jp-bar-btn]', this.bar)].forEach((b) => {
        if (!b) return;
        b.disabled = !enabled;
      });
      if (this.atc) this.atc.textContent = label;
    }

    /* ---------- Add-ons + totals ---------- */
    updateTotals() {
      let count = 0;
      let sum = 0;
      this.addons.forEach((a) => {
        const cb = $('[data-jp-addon-check]', a);
        const sel = $('[data-jp-addon-select]', a);
        if (sel) {
          const opt = sel.selectedOptions[0];
          cb.value = sel.value;
          cb.dataset.price = opt.dataset.price;
          const pr = $('[data-jp-addon-price]', a);
          if (pr) pr.textContent = this.m(opt.dataset.price);
          const s = $('[data-jp-addon-compare]', a);
          const c = Number(opt.dataset.compare) || 0;
          if (s) { s.hidden = !(c > Number(opt.dataset.price)); s.textContent = this.m(c); }
        }
        a.classList.toggle('is-on', cb.checked);
        if (cb.checked) { count += 1; sum += Number(cb.dataset.price) || 0; }
      });
      const q = Math.max(1, parseInt(this.qty && this.qty.value, 10) || 1);
      const total = (this.current ? this.current.price : 0) * q + sum;
      const t = $('[data-jp-total]', this.el);
      if (t) t.textContent = this.m(total);
      const note = $('[data-jp-total-note]', this.el);
      if (note) {
        const s = this.data.strings;
        note.textContent = count === 0 ? '' : (count === 1 ? s.addonOne : s.addonMany.replace('[count]', count));
      }
      const bp = this.bar && $('[data-jp-bar-price]', this.bar);
      if (bp) bp.textContent = this.m(total);
    }

    /* ---------- Buy ---------- */
    bindBuy() {
      this.addons.forEach((a) => a.addEventListener('change', () => this.updateTotals()));
      $$('[data-jp-qty]', this.el).forEach((b) => b.addEventListener('click', () => {
        const q = Math.max(1, (parseInt(this.qty.value, 10) || 1) + Number(b.dataset.jpQty));
        this.qty.value = q;
        this.updateTotals();
      }));
      if (this.qty) this.qty.addEventListener('input', () => this.updateTotals());
      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });
      if (this.toast) {
        const x = $('[data-jp-toast-close]', this.toast);
        if (x) x.addEventListener('click', () => { this.toast.hidden = true; });
      }
    }
    async add() {
      if (!this.current || !this.current.available) return;
      const items = [{ id: this.current.id, quantity: Math.max(1, parseInt(this.qty.value, 10) || 1) }];
      this.addons.forEach((a) => {
        const cb = $('[data-jp-addon-check]', a);
        if (cb.checked) items.push({ id: Number(cb.value), quantity: 1 });
      });
      this.err.hidden = true;
      this.atc.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || this.data.strings.error);
        this.showToast(data.items || [data]);
        this.refreshCount();
      } catch (e) {
        this.err.textContent = e.message || this.data.strings.error;
        this.err.hidden = false;
      } finally {
        this.atc.removeAttribute('aria-busy');
      }
    }
    showToast(items) {
      if (!this.toast) return;
      const ul = $('[data-jp-toast-items]', this.toast);
      ul.innerHTML = '';
      items.forEach((it) => {
        const li = document.createElement('li');
        const img = it.image ? document.createElement('img') : document.createElement('i');
        if (it.image) { img.src = `${it.image}${it.image.includes('?') ? '&' : '?'}width=120`; img.alt = ''; }
        const txt = document.createElement('span');
        const b = document.createElement('b');
        b.textContent = it.product_title;
        txt.append(b);
        if (it.variant_title && !it.product_has_only_default_variant) txt.append(document.createTextNode(it.variant_title));
        const em = document.createElement('em');
        em.textContent = `${it.quantity} × ${this.m(it.final_price != null ? it.final_price : it.price)}`;
        li.append(img, txt, em);
        ul.append(li);
      });
      this.toast.hidden = false;
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => { this.toast.hidden = true; }, 9000);
    }
    async refreshCount() {
      try {
        const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
        const link = document.getElementById('cart-icon-bubble');
        if (link) {
          let c = link.querySelector('.cnt');
          if (!c) { c = document.createElement('span'); c.className = 'cnt'; link.append(c); }
          c.textContent = cart.item_count;
        }
        if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'jr6-product', cartData: cart });
      } catch (e) { /* noop */ }
    }

    /* ---------- Sticky bar ---------- */
    bindBar() {
      if (!this.bar || !('IntersectionObserver' in window)) return;
      const buy = $('[data-jp-buy]', this.el);
      const btn = $('[data-jp-bar-btn]', this.bar);
      if (btn) btn.addEventListener('click', () => {
        if (this.form.requestSubmit) this.form.requestSubmit(); else this.add();
      });
      new IntersectionObserver(([e]) => {
        const on = !e.isIntersecting && e.boundingClientRect.top < 0;
        this.bar.classList.toggle('on', on);
        this.bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        this.bar.inert = !on;
        document.body.classList.toggle('jp-bar-on', on);
      }).observe(buy);
    }

    /* ---------- Lightbox ---------- */
    bindLightbox() {
      if (!this.lb || typeof this.lb.showModal !== 'function') return;
      const img = $('[data-jp-lb-img]', this.lb);
      const list = () => this.visible().map((s) => $('[data-jp-zoom]', s)).filter(Boolean);
      const show = (i) => {
        const l = list();
        if (!l.length) return;
        this.lbIndex = ((i % l.length) + l.length) % l.length;
        const z = l[this.lbIndex];
        img.src = z.dataset.full;
        const src = $('img', z);
        img.alt = src ? src.alt : '';
      };
      this.slides.forEach((s) => {
        const z = $('[data-jp-zoom]', s);
        if (z) z.addEventListener('click', () => { show(list().indexOf(z)); this.lb.showModal(); });
      });
      $('[data-jp-lb-close]', this.lb).addEventListener('click', () => this.lb.close());
      $('[data-jp-lb-prev]', this.lb).addEventListener('click', () => show(this.lbIndex - 1));
      $('[data-jp-lb-next]', this.lb).addEventListener('click', () => show(this.lbIndex + 1));
      this.lb.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') show(this.lbIndex - 1);
        if (e.key === 'ArrowRight') show(this.lbIndex + 1);
      });
      this.lb.addEventListener('click', (e) => { if (e.target === this.lb) this.lb.close(); });
      this.lb.addEventListener('close', () => this.goTo(this.lbIndex || 0, false));
    }
  }

  const init = (scope) => $$('[data-jp]', scope || document).forEach((el) => {
    if (!el.jrProduct) el.jrProduct = new JRProduct(el);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
